import Modal from "../Modal/Modal";
import React, { useEffect, useState } from "react";
import { useApp } from "../../contexts";
import styled from "styled-components";
import { JCBCardIcon } from "../Icons/JCBCardIcon";
import { VisaCardNewIcon } from "../Icons/VisaCardNewIcon";
import { MasterCardIcon } from "../Icons/MasterCardIcon";
import { AmexCardIcon } from "../Icons/AmexCardIcon";
import { DiscoverCardIcon } from "../Icons/DiscoverCardIcon";
import { DinersCardIcon } from "../Icons/DinersCardIcon";
import { PaymentCardIconSelected } from "../Icons/PaymentCardIconSelected";
import FormButton from "../FormCustom2/Button";
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';
import * as Notification from "../../Notification";
import InputMask from "react-input-mask";
import { modifyShopifyPayment, querySubCard } from "../../services/app";
import { ENCRYPT_SESSION_ID, encryptMessageWeb } from "../../utils/helper";


const ContentWaper = styled.div`
  max-height: 80vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;
export const WalletDetailNotify = styled.div`
  background: white;
  border-radius: 10px;
  padding: 10px 15px;
  display: flex;
  align-items: flex-start;
  font-weight: 400;
  font-size: 14px;
  line-height: 25px;
  color: #000000;
  margin-bottom: 6px;
  border: 0;
  & svg {
    margin-top: 3px;
    margin-right: 12px;
    width: 20px;
    height: 20px;
    flex: none;
  }

  & > div {
    flex: 1;
  }

  & h1 {
    font-weight: 700;
    font-size: 16px;
    line-height: 25px;
    color: #000000;
    margin-bottom: 6px;
  }

  & ul {
    margin-bottom: 0;
    list-style: disc;
    padding-left: 18px;

    li {
      margin-top: 16px;
    }
  }

  @media screen and (max-width: 1024px) {
    & {
      //font-size: 14px;
      padding: 10px 15px;
      //margin-top: 50px;
      width: 100% !important;
    }
  }
`;
const DEFAULT_CARD = {
  cvc: "",
  expiry: "",
  name: "",
  number: "",
  issuer: "",
};
export const ModalUpdateCard = ({ value, ...props }) => {
  const { T } = useApp();
  const onClose = () => {
    props.onClose();
  };
  const [isLoading, setIsLoading] = useState(false)
  const [focused, setFocused] = useState("");
  const [cardList, setCardList] = useState([]);
  const [isNewCard, $isNewCard] = useState(false);
  const [cardData, setCardData] = useState(null);
  const handleInputFocus = ({ target }) => {
    setFocused(target.id);
  };
  useEffect(() => {
    querySubCard().then((res) => {
      setCardList(res?.data?.data?.cards || [])
    })
  }, [])
  const handleUpdateCard = () => {
    if (isLoading) return true;
    const formDataObject = {}
    formDataObject.expyy = (cardData.expiry.split('/')?.[1] || '')?.replaceAll(" ", "");
    formDataObject.expmm = (cardData.expiry.split('/')?.[0] || '')?.replaceAll(" ", "");
    formDataObject.cardnumber = cardData.number.split(" ").join("");
    formDataObject.cvc = cardData.cvc;
    const requestBody = encryptMessageWeb(JSON.stringify(formDataObject), ENCRYPT_SESSION_ID);
    setIsLoading(true)
    modifyShopifyPayment(requestBody)
      .then((res) => {
        if (res.data?.data?.success) {
          Notification.success(T("Card updated successful!"));
          onClose();
        } else {
          Notification.error(T("Invalid card information! Please try again!"));
        }
        setIsLoading(false);
      })
      .catch((err) => {
        Notification.error(T("Invalid card information! Please try again!"));
        setIsLoading(false);
      });
  };
  const handleSelectPayment = (payment) => {
    setCardData(payment);
  };
  const getCardIcon = (card) => {
    switch (card.card_type) {
      case "VISA":
        return <VisaCardNewIcon />;
      case "AMEX":
        return <AmexCardIcon />;
      case "MASTERCARD":
        return <MasterCardIcon />;
      case "DISCOVER":
        return <DiscoverCardIcon />;
      case "DINERS":
        return <DinersCardIcon />;
      case "JCB":
        return <JCBCardIcon />;
      default:
        return <VisaCardNewIcon />;
    }
  }
  const handleCardNumber = () => {
    if (!cardData?.number) return
    const cardReplace = cardData?.number
      .replaceAll("****", "")
      .replaceAll(" ", "");
        console.log(cardReplace);

    if (cardReplace.length !== 4) return
    setCardData({...cardData, number: ''});  
  }
  const trimSpace = (str) => {
    if (!str || str.length === 0) return '';
    return str.replaceAll(" ", '');
  }
  return (
    <Modal onClose={onClose}>
      <Modal.ModalBg2 onClose={onClose} />
      <Modal.Container2
        width="850px"
        className={"!bg-[#F5F5F5]"}
        onClose={onClose}
      >
        <ContentWaper>
          <div className="text-black text-center font-medium text-[20px] lg:text-[30px] tracking-[-0.96px]">
            {props?.title}
          </div>
          <div className="mt-[20px] lg:mt-[20px]">
            <div>
              <WalletDetailNotify style={{ marginRight: 0 }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                >
                  <g clipPath="url(#clip0_2694_81806)">
                    <path
                      d="M3.65031 2.9347C5.60075 0.977564 7.95887 0 10.7227 0C13.4864 0 15.8426 0.977564 17.795 2.9347C19.7474 4.89183 20.7227 7.24559 20.7227 10C20.7227 12.7544 19.7474 15.1102 17.795 17.0673C15.8426 19.0244 13.4864 20 10.7227 20C7.95887 20 5.60075 19.0224 3.65031 17.0673C1.69987 15.1122 0.722656 12.7544 0.722656 10C0.722656 7.24559 1.69788 4.88982 3.65031 2.9347ZM5.07917 15.6811C6.63992 17.2456 8.52042 18.0288 10.7227 18.0288C12.9249 18.0288 14.8054 17.2456 16.3661 15.6811C17.9269 14.1166 18.7083 12.2236 18.7083 10C18.7083 7.77644 17.9269 5.88542 16.3661 4.31891C14.8054 2.7524 12.9229 1.97115 10.7227 1.97115C8.52242 1.97115 6.63992 2.75441 5.07917 4.31891C3.51842 5.88341 2.73704 7.77845 2.73704 10C2.73704 12.2216 3.51642 14.1166 5.07917 15.6811ZM9.71546 6.99519V4.97596H11.7298V6.99519H9.71546ZM9.71546 15.024V9.01442H11.7298V15.024H9.71546Z"
                      fill="#606062"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2694_81806">
                      <rect
                        width="20"
                        height="20"
                        fill="white"
                        transform="translate(0.71875)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <div
                  dangerouslySetInnerHTML={{
                    __html: T(
                      `Kindly note that the modification of card information will presently be applicable to ART PLUS and Avatar Subscription only.`
                    ),
                  }}
                />
              </WalletDetailNotify>
              <div className="payment-list mt-[20px]">
                <div className="text-[20px] text-black font-medium mb-2">
                  {T("Payment option")}
                </div>
                <ul className="list-card flex flex-col space-y-[20px]">
                  {cardList.map((item) => (
                    <li
                      className="flex justify-between items-center bg-white rounded-[12px] p-[16px] cursor-pointer"
                      onClick={() =>
                        handleSelectPayment({
                          id: item.id,
                          cvc: "",
                          expiry: trimSpace(item.card_expiry),
                          name: "",
                          number: `**** **** **** ${item.card_number}`,
                          issuer: item?.card_type?.toLowerCase() || "visa",
                        })
                      }
                    >
                      <div className="flex justify-start items-center gap-[12px]">
                        <div className="card-img">{getCardIcon(item)}</div>
                        <div className="text-[#222] text-[16px] font-[500]">
                          **** **** **** {item.card_number}
                        </div>
                      </div>
                      <div>
                        {cardData?.id === item.id ? (
                          <PaymentCardIconSelected />
                        ) : (
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle
                              cx="10"
                              cy="10"
                              r="9.25"
                              stroke="#4B4B4B"
                              strokeWidth="1.5"
                            />
                          </svg>
                        )}
                      </div>
                    </li>
                  ))}
                  <li
                    className="flex justify-between items-center bg-white rounded-[12px] p-[16px] cursor-pointer"
                    onClick={() => {
                      $isNewCard(true);
                      handleSelectPayment(DEFAULT_CARD);
                    }}
                  >
                    <div className="flex justify-start items-center gap-[12px]">
                      <div className="card-img">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M3.5 9.398C3.5 8.37292 3.5 7.86038 3.70266 7.47025C3.87343 7.14149 4.14149 6.87343 4.47025 6.70266C4.86038 6.5 5.37292 6.5 6.398 6.5H17.602C18.6271 6.5 19.1396 6.5 19.5298 6.70266C19.8585 6.87343 20.1266 7.14149 20.2973 7.47025C20.5 7.86038 20.5 8.37292 20.5 9.398V15.602C20.5 16.6271 20.5 17.1396 20.2973 17.5298C20.1266 17.8585 19.8585 18.1266 19.5298 18.2973C19.1396 18.5 18.6271 18.5 17.602 18.5H6.398C5.37292 18.5 4.86038 18.5 4.47025 18.2973C4.14149 18.1266 3.87343 17.8585 3.70266 17.5298C3.5 17.1396 3.5 16.6271 3.5 15.602V9.398Z"
                            stroke="#222222"
                          />
                          <path
                            d="M3.5 10.5L20.5 10.5"
                            stroke="#222222"
                            strokeLinecap="round"
                          />
                          <circle cx="6.5" cy="15.5" r="0.5" fill="#222222" />
                        </svg>
                      </div>
                      <div className="text-[#222] text-[16px] font-[500]">
                        {cardList?.length === 0
                          ? T("Add a new card")
                          : T("Update card information")}
                      </div>
                    </div>
                    <div>
                      {isNewCard ? (
                        <PaymentCardIconSelected />
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="10"
                            cy="10"
                            r="9.25"
                            stroke="#4B4B4B"
                            strokeWidth="1.5"
                          />
                        </svg>
                      )}
                    </div>
                  </li>
                </ul>
              </div>
              {cardData && (
                <div className="card-detail mt-[20px]">
                  <div className="text-[20px] text-black font-medium mb-2">
                    {T("Card details")}
                  </div>
                  <div className="flex justify-between items-start flex-wrap lg:flex-nowrap lg:space-x-[20px]">
                    <div className="w-full lg:w-[50%]">
                      <InputMask
                        mask="9999 9999 9999 9999"
                        value={cardData.number}
                        onChange={(e) =>
                          setCardData({ ...cardData, number: e.target.value })
                        }
                        disabled={!!cardData.id}
                        maskChar="*"
                      >
                        {() => (
                          <input
                            id="number"
                            type="text"
                            placeholder={T("Card Number")}
                            className="border border-solid border-[#0000004D] px-[12px] py-[12px] text-sm rounded-[8px] w-full mb-[20px]"
                            onFocusCapture={handleInputFocus}
                          />
                        )}
                      </InputMask>

                      {/* <input
                      id="name"
                      className="border border-solid border-[#0000004D] px-[12px] !py-[12px] rounded-[8px] w-full mb-[20px]"
                      value={cardData.name}
                      placeholder={T("Card Holder")}
                      onChange={(e) =>
                        setCardData({ ...cardData, name: e.target.value })
                      }
                      onFocusCapture={handleInputFocus}
                    /> */}

                      <div className="flex justify-between items-center gap-[20px]">
                        <InputMask
                          mask="99/99"
                          value={cardData.expiry}
                          onChange={(e) => {
                            setCardData({
                              ...cardData,
                              expiry: e.target.value,
                            });
                          }}
                          disabled={!!cardData.id}
                          maskChar=" "
                        >
                          {() => (
                            <input
                              id="expiry"
                              className="border border-solid border-[#0000004D] px-[12px]  text-sm !py-[12px] rounded-[8px] w-full mb-[20px]"
                              placeholder={T("Expiration: mm/yy")}
                              onFocusCapture={handleInputFocus}
                            />
                          )}
                        </InputMask>

                        <InputMask
                          mask="999"
                          value={cardData.cvc}
                          onChange={(e) => {
                            setCardData({ ...cardData, cvc: e.target.value });
                          }}
                          disabled={!!cardData.id}
                          maskChar=" "
                        >
                          {() => (
                            <input
                              id="cvc"
                              placeholder={T("CVC")}
                              className="border border-solid border-[#0000004D] px-[12px] text-sm !py-[12px] rounded-[8px] w-full mb-[20px]"
                              onFocusCapture={handleInputFocus}
                            />
                          )}
                        </InputMask>
                      </div>
                    </div>
                    <Cards
                      cvc={cardData.cvc}
                      expiry={cardData.expiry}
                      focused={focused}
                      name={cardData.name}
                      number={cardData.number}
                      issuer={cardData.issuer}
                      preview={true}
                    />
                  </div>
                </div>
              )}
              <div className="mt-[30px] mb-[20px] md:mb-[10px] flex flex-wrap md:flex-nowrap justify-center items-center gap-[20px]">
                <FormButton
                  className={"black2 w-full md:w-auto"}
                  style={{ marginRight: 0 }}
                  onClick={() => {
                    props.onClose();
                  }}
                >
                  {T("Cancel")}
                </FormButton>
                <FormButton
                  className={"primary2 w-full md:w-auto"}
                  style={{ marginRight: 0 }}
                  onClick={() => {
                    handleUpdateCard();
                  }}
                  disabled={isLoading}
                >
                  {T("Update")}
                </FormButton>
              </div>
            </div>
          </div>
        </ContentWaper>
      </Modal.Container2>
    </Modal>
  );
};
